import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	announcementTitleNonFinal: {
		id: 'periscope.ui.suggestions.compass-suggestions.announcement-title-non-final',
		defaultMessage: '<b>{senderName}</b> to <b>{receiverName}</b>',
		description:
			'This is message to show this announcement info is from sender name to receiver name.',
	},
	announcementTargetDateInfoNonFinal: {
		id: 'periscope.ui.suggestions.compass-suggestions.announcement-target-date-info-non-final',
		defaultMessage: 'Announcement takes effect on: {targetDate}',
		description: 'This is the label for the target date info in the announcement task.',
	},
	actionButtonNonFinal: {
		id: 'periscope.ui.suggestions.compass-suggestions.action-button-non-final',
		defaultMessage: 'Acknowledge',
		description: 'This is the label for the action button in the announcement task.',
	},
	viewFullAnnouncementNonFinal: {
		id: 'periscope.ui.suggestions.compass-suggestions.view-full-announcement-non-final',
		defaultMessage: 'View full announcement',
		description: 'This is the label for the view full announcement link in the announcement task.',
	},
});
